<template>
  <Modal max-width="400" title="Backup e Restore" title-section-mobile="Backup e Restore" controlsDirection="right">
    <p class="text-caption">Veja como solicitar seu Backup e Restore, e entenda os valores acessando o artigo no nosso site.</p>
    <template #append>
      <Button color="primary" label="Talvez outra hora" text @click="toggleModal"/>
      <Button color="primary" label="Acessar" @click="redirect"/>
    </template>
  </Modal>
</template>

<script>
import { Button, Modal } from '@locaweb/design-system-vue'
export default {
  components: { Button, Modal },
  methods: {
    toggleModal () {
      this.$emit('closeCancel')
    },
    redirect () {
      window.open('https://www.locaweb.com.br/ajuda/wiki/como-solicitar-um-backup-ou-restore-do-meu-site-hospedagem-wordpress-locaweb/', '_blank')
      this.toggleModal()
    }
  }
}
</script>
